/* Rewards CTA. Replaces the legacy anchor with a first-class button
 * that opens Stamped's rewards panel in place, with visible feedback
 * the whole way. If Stamped cannot be opened in place within ~7s,
 * falls back to Stamped's URL trigger and keeps the button in its
 * "Opening" state across the reload so there is no silent gap. */
(() => {
  const LAUNCHER = '.stamped-launcher-button, [class*="rewards-launcher"] button, [class*="rewards-launcher"]';
  const PANEL = '[class*="stamped-rewards-base"], [class*="stamped-rewards-widget"]';
  const FLAG = 'vitae-rewards-opening';

  const panelVisible = () => {
    const el = document.querySelector(PANEL);
    return !!(el && el.offsetWidth > 200 && el.offsetHeight > 200);
  };

  /* Any sign the Stamped widget actually loaded. When ad blockers or
     DNS filters block Stamped's CDN, nothing can ever open the panel
     (the URL trigger needs the widget too), so a reload is pointless. */
  const stampedPresent = () =>
    !!(window.StampedFn || document.querySelector(LAUNCHER) || document.querySelector(PANEL));

  const tryTrigger = () => {
    try {
      const fn = window.StampedFn;
      if (fn && typeof fn.toggleRewardsModal === 'function') { fn.toggleRewardsModal(); return true; }
    } catch { /* keep going */ }
    try {
      const launcher = document.querySelector(LAUNCHER);
      if (launcher) { launcher.click(); return true; }
    } catch { /* keep going */ }
    return false;
  };

  const init = () => {
    const legacy = document.querySelector('.rte a[href*="rewards-launcher=open"]');
    if (!legacy) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vitae-rewards-cta';
    btn.textContent = 'Open rewards panel';
    legacy.replaceWith(btn);

    const setBusy = (on) => {
      btn.classList.toggle('vitae-cta-busy', on);
      btn.textContent = on ? 'Opening…' : 'Open rewards panel';
    };

    const setNote = (text) => {
      let n = btn.parentElement && btn.parentElement.querySelector('.vitae-rewards-note');
      if (!text) { if (n) n.remove(); return; }
      if (!n) {
        n = document.createElement('p');
        n.className = 'vitae-rewards-note';
        btn.insertAdjacentElement('afterend', n);
      }
      n.textContent = text;
    };

    const fail = () => {
      setBusy(false);
      btn.textContent = 'Try again';
      setNote(
        stampedPresent()
          ? 'The rewards panel is taking longer than usual. Please try again in a moment.'
          : 'The rewards panel could not load. It may be blocked by an ad blocker or privacy extension - please allow stamped.io for this site, then try again.'
      );
    };

    const watch = (deadlineMs, onTimeout) => {
      const started = Date.now();
      let lastTrigger = 0;
      const tick = () => {
        if (panelVisible()) { setBusy(false); setNote(''); return; }
        /* Re-trigger while nothing is visible: a fire that lands
           during Stamped's half-initialized window silently no-ops,
           so a single attempt is a coin flip. Spacing prevents a
           toggle from closing a panel that opened between checks. */
        if (Date.now() - lastTrigger > 1500) {
          if (tryTrigger()) lastTrigger = Date.now();
        }
        if (Date.now() - started < deadlineMs) setTimeout(tick, 250);
        else onTimeout();
      };
      tick();
    };

    /* Arriving from the fallback reload: keep showing progress until
       Stamped auto-opens via its URL trigger */
    let pending = false;
    try { pending = sessionStorage.getItem(FLAG) === '1'; sessionStorage.removeItem(FLAG); } catch { /* noop */ }
    if (pending && /rewards-launcher=open/.test(window.location.search)) {
      setBusy(true);
      watch(15000, fail);
    }

    btn.addEventListener('click', () => {
      if (btn.classList.contains('vitae-cta-busy')) return;
      setBusy(true);
      setNote('');
      watch(7000, () => {
        /* Reload with the URL trigger only when the widget actually
           loaded; if it never appeared, a reload cannot help */
        if (!stampedPresent()) { fail(); return; }
        try { sessionStorage.setItem(FLAG, '1'); } catch { /* noop */ }
        const u = new URL(window.location.href);
        u.searchParams.set('rewards-launcher', 'open');
        window.location.href = u.toString();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
